import { SIZE_FULL } from '@/lib/gridElements/size';

import { StoriesWidget } from '@/components/pages/analyze/widget/StoriesWidget';

export const mostRecentStoriesConfig = {
    title: 'chart.instagram.stories.widget_most_recent_stories',
    id: 'widget_most_recent_stories',
    size: SIZE_FULL,
    sortFields: [
        'created',
        'impressions_views',
        'completed',
        'completed_rate',
        'replies',
        'exits',
        'exits_rate',
        'taps_forward',
        'taps_back'
    ],
    type: 'widget',
    element: StoriesWidget
};
